import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    NEXTAUTH_SECRET: z.string().min(1),
  },
  client: {
    NEXT_PUBLIC_COGNITO_CLIENT_ID: z
      .string()
      .min(1, "Cognito Client ID is Required"),
    NEXT_PUBLIC_COGNITO_USER_POOL_ID: z
      .string()
      .min(1, "Cognito User Pool ID is Required"),
    NEXT_PUBLIC_COGNITO_DOMAIN_NAME: z
      .string()
      .min(1, "Cognito Identity Pool ID is Required"),
    NEXT_PUBLIC_COGNITO_COOKIE_DOMAIN: z.string().default(".localhost"),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_COGNITO_CLIENT_ID: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
    NEXT_PUBLIC_COGNITO_USER_POOL_ID: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
    NEXT_PUBLIC_COGNITO_DOMAIN_NAME: process.env.NEXT_PUBLIC_COGNITO_DOMAIN_NAME,
    NEXT_PUBLIC_COGNITO_COOKIE_DOMAIN: process.env.NEXT_PUBLIC_COGNITO_COOKIE_DOMAIN,
  },
  skipValidation: !!process.env.CI || !!process.env.SKIP_ENV_VALIDATION,
});
